// Using an interface object so it's easier to change values should we decide on a different spec
export default {
  LABEL: 'label',
  T1: 't1',
  T2: 't2',
}
